import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { for: "dodownloadresizedimages" }
const _hoisted_2 = { class: "google-photos-toolbar" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = {
  key: 0,
  class: "error"
}
const _hoisted_6 = {
  key: 1,
  class: "google-photos-picker-urls"
}
const _hoisted_7 = { key: 0 }
const _hoisted_8 = {
  key: 1,
  class: "links"
}
const _hoisted_9 = ["href"]
const _hoisted_10 = ["href"]
const _hoisted_11 = { class: "" }
const _hoisted_12 = { class: "" }
const _hoisted_13 = {
  key: 1,
  id: "google-picker-result"
}
const _hoisted_14 = { class: "image-container" }
const _hoisted_15 = ["value"]
const _hoisted_16 = ["src", "alt"]

import {computed, onMounted, PropType, ref, watch} from "vue";
import {UploaderI18n} from "../types/I18n";
import {UploadFile} from "../types/UploadFile";
import {GooglePickerUrls} from "../types/GooglePickerUrls";
import {MediaItem, MediaType, VideoProcessingStatus} from "../types/GooglePhotosTypes";
import PagingBar from "./PagingBar.vue";
import GoogleAccountSelector from "./GoogleAccountSelector.vue";
import QRCode from "./QRCode.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'GoogleFilePicker',
  props: {
    i18n: {
        type: Object as PropType<UploaderI18n>,
        required: true
    },
    googlePickerUrls: {
        type: Object as PropType<GooglePickerUrls>,
        require: true
    },
    doResize: Boolean,
    maxImageSize: Number
},
  emits: ['addFileCallback'],
  setup(__props, { emit: __emit }) {

const props = __props

const emit = __emit

const session = ref(null)
const responseError = ref(null)
const imagesData = ref({mediaItems: [], pageSize: 5})
const currentPageNumber = ref(0)
const doDownloadResizedImage = ref( 0)
doDownloadResizedImage.value = JSON.parse(localStorage.getItem('eg-fileupload-dodownloadresizedimages'))
watch(doDownloadResizedImage, (newVal: boolean) => {
    localStorage.setItem('eg-fileupload-dodownloadresizedimages', JSON.stringify(newVal))
})
const pagingData = computed(() => {
    if (!imagesData.value.mediaItems) return

    const pageSize = imagesData.value.pageSize
    const pagesCount = Math.ceil(imagesData.value.mediaItems.length / pageSize)
    const currentPageContent = imagesData.value.mediaItems.slice(currentPageNumber.value*pageSize, (currentPageNumber.value+1)*pageSize)

    // load the missing thumbnails
    currentPageContent.forEach((mediaItem: MediaItem) => {
        if (!mediaItem.imageBlobThumbnailReqested) {
            mediaItem.imageBlobThumbnailReqested = true
            if (mediaItem.type === MediaType.photo || mediaItem.type === MediaType.video) {
                getImage(mediaItem).then((blob) => {
                    mediaItem.imageBlobThumbnail = URL.createObjectURL(blob)
                })
            }
        }
    })

    return  {
        pagesCount,
        currentPage: currentPageNumber.value,
        mediaItems: currentPageContent
    }
})

let mounted = false;
onMounted(() => {
    gameLoop(false)
    mounted = true
})

function goToPage(index: bigint) {
    currentPageNumber.value = index
}

function addGoogleAccountToUrl(url: string): string {
    return url + '&id=' + activeGoogleAccount.value
}

let pollTimeout: any = null
const gameLoop = async (doNewSession: boolean) => {
    if (activeGoogleAccount.value === null) return
    responseError.value = null
    session.value = null
    imagesData.value = {mediaItems: [], pageSize: 5}
    if (clearTimeout) clearTimeout(pollTimeout)

    try {
        const url = addGoogleAccountToUrl(doNewSession ? props.googlePickerUrls.googlePickerUrlNewSession : props.googlePickerUrls.googlePickerUrlGetSession);
        const response = await fetch(url, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            }
        });

        const responseData = await response.json();

        if (responseData["error"]) {
            console.log("Encountered error while fetching data from: ", responseData)
            responseError.value = responseData.error
            return
        }

        session.value = responseData

        if (responseData.mediaItemsSet) {
            listImages()
            return
        }
    } catch (e) {
        console.log('Error while fetching data', e);
    }
    const pollForImages = () => {
        if (clearTimeout) clearTimeout(pollTimeout)
        pollTimeout = setTimeout(() => {
            fetch(addGoogleAccountToUrl(props.googlePickerUrls.googlePickerUrlGetSession))
                .then((response) => response.json())
                .then((responseData) => {
                    session.value = responseData
                    if (responseData.mediaItemsSet) {
                        listImages()
                    } else {
                        pollForImages()
                    }
                })
        }, 5000) // default to poll every 5 seconds
    }
    pollForImages()
}

const getImage = async (mediaItem: MediaItem, sizeParams:string = "=w128-h128") => {
    const response = await fetch(addGoogleAccountToUrl(props.googlePickerUrls.googlePickerUrlGetImage), {
        method: 'POST',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
        },
        body: `baseUrl=${mediaItem.mediaFile.baseUrl}${sizeParams}`
    })
    return await response.blob()
}

const listImages = () => {
    fetch(addGoogleAccountToUrl(props.googlePickerUrls.googlePickerUrlGetImages))
        .then((response) => response.json())
        .then((responseData) => {
            imagesData.value = responseData
        })
}

const startNewSession = () => {
    gameLoop(true)
}

let activeGoogleAccount = ref(null)
const setActiveGoogleAccount = async (accountId: bigint) => {
    if (accountId !== activeGoogleAccount.value) {
        activeGoogleAccount.value = accountId
        if (mounted) {
            await gameLoop(false)
        }
    }
}

const addSelectedFilesToUpload = () => {

    imagesData.value.mediaItems.forEach(async (mediaItem: MediaItem) => {
        let queryParameter = ''

        if (mediaItem.type === MediaType.photo) {
            queryParameter = '=d'
            if (doDownloadResizedImage) {
                queryParameter = `=w${props.maxImageSize}-h${props.maxImageSize}`
            }
        }
        if (mediaItem.type === MediaType.video && mediaItem.mediaFile.mediaFileMetadata.videoMetadata.processingStatus === VideoProcessingStatus.READY) {
            queryParameter = '=dv'
        }

        if (queryParameter === '') return

        const blob = await getImage(mediaItem, queryParameter)
        const uploadFile: UploadFile = {
            localFile: new File([blob], mediaItem.mediaFile.filename, {type: mediaItem.mediaFile.mimeType}),
            name: mediaItem.mediaFile.filename,
            doResize: false
        }
        emit('addFileCallback', uploadFile)
    })
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", null, [
      _createElementVNode("label", _hoisted_1, _toDisplayString(__props.i18n.COM_EVENTGALLERY_EVENT_UPLOAD_DO_DOWNLOAD_RESIZED_IMAGES_LABEL) + ":", 1 /* TEXT */),
      _withDirectives(_createElementVNode("input", {
        type: "checkbox",
        id: "dodownloadresizedimages",
        name: "dodownloadresizedimages",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((doDownloadResizedImage).value = $event))
      }, null, 512 /* NEED_PATCH */), [
        [_vModelCheckbox, doDownloadResizedImage.value]
      ])
    ]),
    _createElementVNode("div", _hoisted_2, [
      (_unref(activeGoogleAccount))
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            class: "btn btn-warning",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (startNewSession()))
          }, _toDisplayString(__props.i18n.COM_EVENTGALLERY_EVENT_UPLOAD_GOOGLE_PHOTOS_START_NEW_SELECTION), 1 /* TEXT */))
        : _createCommentVNode("v-if", true),
      (imagesData.value.mediaItems.length === 0)
        ? (_openBlock(), _createBlock(GoogleAccountSelector, {
            key: 1,
            i18n: __props.i18n,
            "google-picker-url-get-accounts": __props.googlePickerUrls.googlePickerUrlGetAccounts,
            "google-picker-url-manage-accounts": __props.googlePickerUrls.googlePickerUrlManageAccounts,
            onSetActiveGoogleAccount: setActiveGoogleAccount
          }, null, 8 /* PROPS */, ["i18n", "google-picker-url-get-accounts", "google-picker-url-manage-accounts"]))
        : _createCommentVNode("v-if", true)
    ]),
    (_unref(activeGoogleAccount))
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          (!session.value && !responseError.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(__props.i18n.COM_EVENTGALLERY_EVENT_UPLOAD_GOOGLE_PHOTOS_LOADING_SESSION), 1 /* TEXT */))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                (imagesData.value.mediaItems.length === 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                      (responseError.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(responseError.value), 1 /* TEXT */))
                        : _createCommentVNode("v-if", true),
                      (responseError.value == null)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                            _createElementVNode("h1", null, _toDisplayString(__props.i18n.COM_EVENTGALLERY_EVENT_UPLOAD_GOOGLE_PHOTOS_PICKER_HEADLINE), 1 /* TEXT */),
                            (session.value?.pollingConfig)
                              ? (_openBlock(), _createElementBlock("p", _hoisted_7, _toDisplayString(__props.i18n.COM_EVENTGALLERY_EVENT_UPLOAD_GOOGLE_PHOTOS_PICKER_SESSION_RUNTIME.replace('%s', Math.round(parseInt(session.value.pollingConfig.timeoutIn)))), 1 /* TEXT */))
                              : _createCommentVNode("v-if", true),
                            (session.value?.pickerUri)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                                  _createElementVNode("a", {
                                    target: "_blank",
                                    class: "",
                                    href: session.value.pickerUri
                                  }, _toDisplayString(__props.i18n.COM_EVENTGALLERY_EVENT_UPLOAD_GOOGLE_PHOTOS_PICKER_LINK_DESC), 9 /* TEXT, PROPS */, _hoisted_9),
                                  _createElementVNode("a", {
                                    target: "_blank",
                                    class: "",
                                    href: session.value.pickerUri
                                  }, [
                                    _createVNode(QRCode, {
                                      text: session.value.pickerUri,
                                      alt: __props.i18n.COM_EVENTGALLERY_EVENT_UPLOAD_GOOGLE_PHOTOS_PICKER_LINK_DESC
                                    }, null, 8 /* PROPS */, ["text", "alt"])
                                  ], 8 /* PROPS */, _hoisted_10)
                                ]))
                              : _createCommentVNode("v-if", true),
                            _createElementVNode("div", _hoisted_11, [
                              _createElementVNode("p", _hoisted_12, _toDisplayString(__props.i18n.COM_EVENTGALLERY_EVENT_UPLOAD_GOOGLE_PHOTOS_PICKER_RELOAD_DESC), 1 /* TEXT */)
                            ])
                          ]))
                        : _createCommentVNode("v-if", true)
                    ]))
                  : _createCommentVNode("v-if", true),
                (imagesData.value.mediaItems.length > 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                      _createElementVNode("h3", null, _toDisplayString(__props.i18n.COM_EVENTGALLERY_EVENT_UPLOAD_GOOGLE_PHOTOS_PICKER_SELECTED_IMAGES_DESC.replace('%s', imagesData.value.mediaItems.length)), 1 /* TEXT */),
                      _createVNode(PagingBar, {
                        pagingData: pagingData.value,
                        onGoToPage: goToPage
                      }, null, 8 /* PROPS */, ["pagingData"]),
                      _createElementVNode("div", _hoisted_14, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(pagingData.value?.mediaItems, (value) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: value.id,
                            value: value.id
                          }, [
                            _createElementVNode("img", {
                              src: value.imageBlobThumbnail || 'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==',
                              alt: value.mediaFile.filename
                            }, null, 8 /* PROPS */, _hoisted_16)
                          ], 8 /* PROPS */, _hoisted_15))
                        }), 128 /* KEYED_FRAGMENT */))
                      ]),
                      _createVNode(PagingBar, {
                        pagingData: pagingData.value,
                        onGoToPage: goToPage
                      }, null, 8 /* PROPS */, ["pagingData"]),
                      _createElementVNode("button", {
                        class: "btn btn-primary",
                        onClick: addSelectedFilesToUpload
                      }, _toDisplayString(__props.i18n.COM_EVENTGALLERY_EVENT_UPLOAD_GOOGLE_PHOTOS_PICKER_UPLOAD_BUTTON_LABEL.replace('%s', imagesData.value.mediaItems.length)), 1 /* TEXT */)
                    ]))
                  : _createCommentVNode("v-if", true)
              ], 64 /* STABLE_FRAGMENT */))
        ], 64 /* STABLE_FRAGMENT */))
      : _createCommentVNode("v-if", true)
  ], 64 /* STABLE_FRAGMENT */))
}
}

})